// Accueil AYA — section « Recharge téléphonique et Internet » (entrée AYA Multiservice, compacte).
import React from "react";
import { Smartphone, ArrowRight, ArrowUp, Phone, Globe, Gift, Zap, ShieldCheck } from "lucide-react";

const TILES = [
  { id: "orange", name: "Orange", bg: "#FF7900", fg: "#fff", label: "orange", to: "/multiservice?op=orange" },
  { id: "mtn", name: "MTN", bg: "#FFCB05", fg: "#111", label: "MTN", to: "/multiservice?op=mtn" },
  { id: "moov", name: "Moov Africa", bg: "#0D47A1", fg: "#fff", label: "Moov", to: "/multiservice?op=moov" },
  { id: "canalplus", name: "Canal+", bg: "#111111", fg: "#fff", label: "CANAL+", to: "/multiservice" },
];

const ACTIONS = [
  { id: "credit", Icon: Phone, label: "Acheter du crédit", to: "/multiservice?type=credit" },
  { id: "forfait", Icon: Globe, label: "Acheter un forfait", to: "/multiservice?type=internet" },
  { id: "offrir", Icon: Gift, label: "Offrir à un proche", to: "/multiservice?gift=1" },
];

export default function RechargeHomeSection({ navigate }) {
  return (
    <section style={St.wrap} data-testid="recharge-home-section">
      <div style={St.head}>
        <span style={St.icon}>
          <Smartphone size={13} color="#fff" strokeWidth={2.4} />
          <span style={St.iconBadge}><ArrowUp size={8} color="#fff" strokeWidth={3.4} /></span>
        </span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <h2 style={St.title}>Recharge téléphonique et Internet</h2>
          <p style={St.sub}>Crédit, forfaits et pass pour vous ou un proche</p>
        </div>
        <button style={St.more} data-testid="recharge-see-all" onClick={() => navigate("/multiservice")}>
          Voir tout <ArrowRight size={11} color="#F97316" />
        </button>
      </div>
      <div style={St.tiles} data-testid="recharge-operator-tiles">
        {TILES.map((t) => (
          <button key={t.id} style={St.tile} data-testid={`recharge-tile-${t.id}`} onClick={() => navigate(t.to)}>
            <span style={{ ...St.logo, background: t.bg, color: t.fg, fontSize: t.label.length > 4 ? 8.5 : 11 }}>{t.label}</span>
            <span style={St.tileName}>{t.name}</span>
          </button>
        ))}
      </div>
      <div style={St.actions}>
        {ACTIONS.map((a) => (
          <button key={a.id} style={St.action} data-testid={`recharge-action-${a.id}`} onClick={() => navigate(a.to)}>
            <a.Icon size={12} color="#059669" strokeWidth={2.4} style={{ flexShrink: 0 }} />
            <span style={St.actionLabel}>{a.label}</span>
          </button>
        ))}
      </div>
      <div style={St.trust} data-testid="recharge-trust-line">
        <span style={St.trustItem}><Zap size={10} color="#F59E0B" /> Rapide · Sécurisé · Reçu disponible</span>
        <span style={{ ...St.trustItem, marginLeft: "auto" }}><ShieldCheck size={11} color="#059669" /> Prix à jour</span>
      </div>
    </section>
  );
}

const St = {
  wrap: { marginTop: 11, padding: "9px 9px 8px", borderRadius: 14, background: "rgba(16,185,129,0.06)", border: "1px solid rgba(5,150,105,0.3)" },
  head: { display: "flex", alignItems: "center", gap: 8, marginBottom: 8 },
  icon: { position: "relative", width: 26, height: 26, borderRadius: 8, background: "#059669", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  iconBadge: { position: "absolute", top: -3, right: -3, width: 12, height: 12, borderRadius: "50%", background: "#F97316", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #fff" },
  title: { fontSize: 12.5, fontWeight: 800, margin: 0, color: "var(--ah-title)", lineHeight: 1.15, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  sub: { fontSize: 9.5, color: "var(--ah-muted)", margin: "1px 0 0", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  more: { display: "inline-flex", alignItems: "center", gap: 3, height: 24, padding: "0 9px", borderRadius: 999, border: "1px solid var(--ah-border-strong)", background: "var(--ah-surface-elev)", color: "var(--ah-soft)", fontSize: 10, fontWeight: 700, cursor: "pointer", flexShrink: 0 },
  tiles: { display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 6 },
  tile: { display: "flex", flexDirection: "column", alignItems: "center", gap: 4, padding: "7px 2px 6px", borderRadius: 11, background: "var(--ah-surface-elev, #fff)", border: "1px solid var(--ah-border)", cursor: "pointer", minWidth: 0 },
  logo: { width: 32, height: 32, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, letterSpacing: "-0.2px", flexShrink: 0 },
  tileName: { fontSize: 9.5, fontWeight: 700, color: "var(--ah-title)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%" },
  actions: { display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 6, marginTop: 7 },
  action: { display: "flex", alignItems: "center", justifyContent: "center", gap: 5, height: 28, padding: "0 6px", borderRadius: 999, background: "var(--ah-surface-elev, #fff)", border: "1px solid var(--ah-border)", cursor: "pointer", minWidth: 0 },
  actionLabel: { fontSize: 9, fontWeight: 800, color: "var(--ah-title)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  trust: { display: "flex", alignItems: "center", gap: 6, marginTop: 7, padding: "0 2px", flexWrap: "wrap" },
  trustItem: { display: "inline-flex", alignItems: "center", gap: 3, fontSize: 9, fontWeight: 700, color: "var(--ah-soft)" },
};
